// extracted by mini-css-extract-plugin
export default {"root":"g3as8r","icon":"TrbL5O","text":"h0H1OP"};